/**
 * Render the How-To Schema
 */

import classnames from 'classnames';
import SchemaNotices from './schema-notices';
import './style.scss';
import { __ } from '@wordpress/i18n';
import { createBlock } from '@wordpress/blocks';
import { MediaUpload, RichText, InnerBlocks } from '@wordpress/block-editor';
import { Button } from '@wordpress/components';
import styles from './editor.lazy.scss';
import {useLayoutEffect} from "react";

const ALLOWED_BLOCKS = ['wpsp/how-to-child'];

const howto = [];

export default function Render(props) {
	useLayoutEffect(() => {
		styles.use();
		return () => {
			styles.unuse();
		};
	}, []);
	props = props.parentProps;

	// Setup the attributes
	const {
		className,
		attributes,
		setAttributes,
		insertBlocksAfter,
		mergeBlocks,
		onReplace,
		attributes: {
			currencyType,
			timeIn,
			headingTag,
			showEstcost,
			showTotaltime,
			showMaterials,
			showTools,
			toolsTitle,
			materialTitle,
			stepsTitle,
			tools,
			materials,
			timeNeeded,
			estCost,
			mainimage,
			headingTitle,
			headingDesc,
			time,
			cost,
		},
	} = props;

	const splitBlock = (before, after, ...blocks) => {
		if (after) {
			// Append "After" content as a new paragraph block to the end of
			// any other blocks being inserted after the current paragraph.
			blocks.push(createBlock('core/paragraph', { content: after }));
		}

		if (blocks.length && insertBlocksAfter) {
			insertBlocksAfter(blocks);
		}

		const { content } = attributes;
		if (!before) {
			// If before content is omitted, treat as intent to delete block.
			onReplace([]);
		} else if (content !== before) {
			// Only update content if it has in-fact changed. In case that user
			// has created a new paragraph at end of an existing one, the value
			// of before will be strictly equal to the current content.
			setAttributes({ content: before });
		}
	};

	const savematerials = (value, index) => {
		const newItems = materials.map((item, thisIndex) => {
			if (index === thisIndex) {
				item = { ...item, ...value };
			}

			return item;
		});

		setAttributes({
			materials: newItems,
		});
	};

	const savetools = (value, index) => {
		const newItems = tools.map((item, thisIndex) => {
			if (index === thisIndex) {
				item = { ...item, ...value };
			}

			return item;
		});

		setAttributes({
			tools: newItems,
		});
	};

	let urlChk = '';
	let title = '';
	let url = '';
	if (
		'undefined' !== typeof attributes.mainimage &&
		null !== attributes.mainimage &&
		'' !== attributes.mainimage
	) {
		urlChk = attributes.mainimage.url;
		title = attributes.mainimage.title;
	}
	if ('' !== urlChk) {
		const size = attributes.mainimage.sizes;
		const imageSize = attributes.imgSize;

		if (
			'undefined' !== typeof size &&
			'undefined' !== typeof size[imageSize]
		) {
			url = size[imageSize].url;
		} else {
			url = urlChk;
		}
	}

	let imageIconhtml = '';

	if (mainimage && mainimage.url) {
		imageIconhtml = (
			<img
				className="wpsp-howto__source-image"
				src={url}
				title={title}
				alt=""
			/>
		);
	}
	/* eslint-disable no-shadow */
	const gethowtoChildTemplate = (howtoCount, howto) => {
		let i = 0;
		const templates = [];
		while (i < howtoCount) {
			templates.push(['wpsp/how-to-child', howto[i]]);
			i += 1;
		}
		return templates;
	};
	/* eslint-disable  react/jsx-no-duplicate-props */
	return (
		<>
			<SchemaNotices
				headingTitle={headingTitle}
				headingDesc={headingDesc}
				mainimage={mainimage}
				showTotaltime={showTotaltime}
				timeNeeded={timeNeeded}
				time={time}
				timeIn={timeIn}
				showEstcost={showEstcost}
				estCost={estCost}
				cost={cost}
				currencyType={currencyType}
				tools={tools}
				materials={materials}
				clientId={props.clientId}
			/>
			<div
				className={classnames(
					className,
					`wpsp-block-${props.clientId.substr(0, 8)}`
				)}
			>
				<div className="wpsp-how-to-main-wrap">
					<RichText
						tagName={headingTag}
						placeholder={__(
							'Configure How-to Schema In Schema Pro.'
						)}
						value={headingTitle}
						className="wpsp-howto-heading-text"
						multiline={false}
						onChange={(value) => {
							setAttributes({ headingTitle: value });
						}}
						onMerge={mergeBlocks}
						onSplit={
							insertBlocksAfter
								? (before, after, ...blocks) => {
										setAttributes({ content: before });
										insertBlocksAfter([
											...blocks,
											createBlock('core/paragraph', {
												content: after,
											}),
										]);
								  }
								: undefined
						}
						onRemove={() => onReplace([])}
					/>
					<RichText
						tagName="p"
						placeholder={__(
							'So to get started, you will just need to drag-n-drop the How-to Schema block in the Gutenberg editor.'
						)}
						value={headingDesc}
						className="wpsp-howto-desc-text"
						onChange={(value) =>
							setAttributes({ headingDesc: value })
						}
						onMerge={mergeBlocks}
						onSplit={splitBlock}
						onRemove={() => onReplace([])}
					/>
					{mainimage.url !== '' && (
						<div className="wpsp-howto__source-wrap">
							{' '}
							{imageIconhtml}{' '}
						</div>
					)}
					<MediaUpload
						title={__('Select Image')}
						onSelect={(value) =>
							setAttributes({ mainimage: value })
						}
						allowedTypes={['image']}
						value={mainimage}
						render={({ open }) => (
							<Button isDefault onClick={open}>
								{!mainimage.url
									? __('Select Image')
									: __('Replace image')}
							</Button>
						)}
					/>
					{mainimage.url && (
						<Button
							className="wpsp-rm-btn"
							onClick={() => setAttributes({ mainimage: '' })}
							isLink
							isDestructive
						>
							{__('Remove Image')}
						</Button>
					)}
					<span className="wpsp-howto__time-wrap">
						{showTotaltime && (
							<RichText
								tagName="h4"
								placeholder={__(
									'Total Time Needed ( Minutes ):'
								)}
								value={timeNeeded}
								className="wpsp-howto-timeNeeded-text"
								onChange={(value) =>
									setAttributes({ timeNeeded: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
						{showTotaltime && (
							<RichText
								tagName="p"
								placeholder={__('30')}
								value={time}
								className="wpsp-howto-timeNeeded-value"
								onChange={(value) =>
									setAttributes({ time: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
						{showTotaltime && (
							<RichText
								tagName="p"
								placeholder={__('Minutes')}
								value={timeIn}
								className="wpsp-howto-timeINmin-text"
								onChange={(value) =>
									setAttributes({ timeIn: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
					</span>
					<span className="wpsp-howto__cost-wrap">
						{showEstcost && (
							<RichText
								tagName="h4"
								placeholder={__('Total Cost:')}
								value={estCost}
								className="wpsp-howto-estcost-text"
								onChange={(value) =>
									setAttributes({ estCost: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
						{showEstcost && (
							<RichText
								tagName="p"
								placeholder={__('30')}
								value={cost}
								className="wpsp-howto-estcost-value"
								onChange={(value) =>
									setAttributes({ cost: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
						{showEstcost && (
							<RichText
								tagName="p"
								placeholder={__('USD')}
								value={currencyType}
								className="wpsp-howto-estcost-type"
								onChange={(value) =>
									setAttributes({ currencyType: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
					</span>
					<div className="wpsp-how-to-tools__wrap">
						{showTools && (
							<RichText
								tagName="h4"
								placeholder={__('requirements tools:')}
								value={toolsTitle}
								className="wpsp-howto-req-tools-text"
								onChange={(value) =>
									setAttributes({ toolsTitle: value })
								}
								onMerge={mergeBlocks}
								onSplit={splitBlock}
								onRemove={() => onReplace([])}
							/>
						)}
						{showTools && (
							<div className="wpsp-how-to-tools">
								{tools.map((toolss, index) => {
									return (
										<div
											className={classnames(
												`wpsp-how-to-tools-${index}`,
												'wpsp-how-to-tools-child__wrapper'
											)}
											key={index}
										>
											<div className="wpsp-tools">
												<RichText
													tagName="div"
													placeholder={__(
														'Requirements Tools:'
													)}
													value={
														toolss.add_required_tools
													}
													onChange={(value) => {
														savetools(
															{
																add_required_tools:
																	value,
															},
															index
														);
													}}
													className="wpsp-tools__label"
													placeholder={__(
														'Description'
													)}
													multiline={false}
													allowedFormats={[
														'core/bold',
														'core/italic',
														'core/strikethrough',
													]}
												/>
											</div>
										</div>
									);
								})}
							</div>
						)}
						<div className="wpsp-how-to-materials__wrap">
							{showMaterials && (
								<RichText
									tagName="h4"
									placeholder={__('requirements materials:')}
									value={materialTitle}
									className="wpsp-howto-req-materials-text"
									onChange={(value) =>
										setAttributes({
											materialTitle: value,
										})
									}
									onMerge={mergeBlocks}
									onSplit={splitBlock}
									onRemove={() => onReplace([])}
								/>
							)}
						</div>
						{showMaterials && (
							<div className="wpsp-how-to-materials">
								{materials.map((materialss, index) => {
									return (
										<div
											className={classnames(
												`wpsp-how-to-materials-${index}`,
												'wpsp-how-to-materials-child__wrapper'
											)}
											key={index}
										>
											<div className="wpsp-materials">
												<RichText
													tagName="div"
													placeholder={__(
														'Requirements Materials:'
													)}
													value={
														materialss.add_required_materials
													}
													onChange={(value) => {
														savematerials(
															{
																add_required_materials:
																	value,
															},
															index
														);
													}}
													className="wpsp-materials__label"
													placeholder={__(
														'Description'
													)}
													multiline={false}
													allowedFormats={[
														'core/bold',
														'core/italic',
														'core/strikethrough',
													]}
												/>
											</div>
										</div>
									);
								})}
							</div>
						)}
					</div>
					<div className="wpsp-how-to-steps__wrap">
						<RichText
							tagName="h4"
							placeholder={__('requirements Steps:')}
							value={stepsTitle}
							className="wpsp-howto-req-steps-text"
							onChange={(value) =>
								setAttributes({ stepsTitle: value })
							}
							onMerge={mergeBlocks}
							onSplit={splitBlock}
							onRemove={() => onReplace([])}
						/>
						<div className="wpsp-howto-steps__wrap">
							<InnerBlocks
								template={gethowtoChildTemplate(2, howto)}
								allowedBlocks={ALLOWED_BLOCKS}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
